/* ==========================================================================
   ALBEUX CART SPEED (1 Nov 2026): Add to bag answers at once.
   What was slow: after the tap the page asked the shop to add the bag, then asked it again for the new bag count and contents, and only then
   showed the count and (for a first bag) opened the drawer. Two trips to the shop, one after the other, before anything moved.
   What this does, the moment the Add to bag is tapped (the real adding carries on exactly as before, nothing is skipped):
   1. The bag count in the header goes up by the number added, at once. When the shop answers, the theme sets the true count anyway,
      and if the shop reports a problem the true count is put back.
   2. When the bag was empty the drawer slides open at once instead of waiting for the shop. The "your bag is empty" message is held back
      for that moment (albeux-cart-speed.css) so it can never flash, and the items appear in it as soon as they arrive.
      If the add fails, the drawer closes again and the normal error shows.
   When the bag already has items the theme already opens the drawer at once, so only the count is brought forward.
   Nothing here changes a look, a font or a colour. To switch it off, delete the albeux-cart-speed.js and albeux-cart-speed.css lines in snippets/albeux-fixes.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__albeuxCartSpeed) return;
  window.__albeuxCartSpeed = true;

  var root = document.documentElement;
  var failsafe = 0;

  function icons() { return Array.prototype.slice.call(document.querySelectorAll('cart-icon')); }
  function drawer() { return document.querySelector('theme-drawer#cart-drawer'); }
  function cartIsEmpty() { return !!document.querySelector('cart-drawer-component .cart-drawer--empty'); }

  function clearFlag() {
    clearTimeout(failsafe);
    root.removeAttribute('data-alb-adding');
  }

  /* How many bags this add puts in (the quantity box is not used on the product page, so this is nearly always 1) */
  function quantityOf(event) {
    var n = 0;
    try {
      var lines = event.lines || (event.detail && event.detail.lines) || [];
      for (var i = 0; i < lines.length; i++) n += Number(lines[i].quantity) || 0;
    } catch (e) {}
    return n > 0 ? n : 1;
  }

  /* The header count goes up now; the theme puts the true number in when the shop answers */
  function bump(n) {
    icons().forEach(function (ic) {
      try {
        if (typeof ic.renderCartBubble !== 'function') return;
        var cur = parseInt(ic.currentCartCount, 10);
        if (!isFinite(cur) || cur < 0) cur = 0;
        ic.renderCartBubble(cur + n, true);
      } catch (e) {}
    });
  }

  /* If the add could not be completed, the header count is read back from the shop */
  function reconcile() {
    try {
      fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          icons().forEach(function (ic) {
            try { if (typeof ic.renderCartBubble === 'function') ic.renderCartBubble(cart.item_count, false); } catch (e) {}
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  function onAdd(event) {
    if (!event || event.action !== 'add') return;

    var inModal = false;
    try { inModal = !!(event.target instanceof Element && event.target.closest('dialog:modal')); } catch (e) {}

    /* An empty bag: the theme would wait for the shop before opening the drawer. Open it now. */
    var openedEarly = false;
    if (!inModal && cartIsEmpty()) {
      var auto = document.querySelector('cart-drawer-component[auto-open]');
      var d = drawer();
      if (auto && d && typeof d.open === 'function' && !d.isOpen) {
        root.setAttribute('data-alb-adding', '');
        failsafe = setTimeout(clearFlag, 8000);
        try { d.open(); openedEarly = true; } catch (e) { clearFlag(); }
      }
    }

    bump(quantityOf(event));

    function settle(failed) {
      if (!openedEarly) return;
      if (failed) {
        clearFlag();
        try { if (cartIsEmpty() && drawer() && drawer().close) drawer().close(); } catch (e) {}
        return;
      }
      /* Keep the empty message hidden until the items have been put into the drawer, then let go */
      var tries = 0;
      (function wait() {
        if (!cartIsEmpty() || ++tries > 40) { clearFlag(); return; }
        setTimeout(wait, 60);
      })();
    }

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(
        function (res) { settle(!!(res && res.detail && res.detail.didError)); },
        function () { settle(true); reconcile(); }
      );
    }
  }

  /* The event name comes from the same module the theme uses, so it can never be out of step with it */
  try {
    import('@shopify/events').then(function (m) {
      var name = m && m.StandardEvents && m.StandardEvents.cartLinesUpdate;
      if (name) document.addEventListener(name, onAdd);
    }).catch(function () {});
  } catch (e) {}
})();
